













import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { CommonUtils } from '@/util/commonUtils';

@Component({})
export default class UnauthorizedPage extends Vue {
    private isRejected = false;
    private async mounted() {
        await this.getPartnerProfile();
        if (this.isRejected) {
            this.$router.push({ name: MedTransGoConstants.VIEW_REJECTED_DOCUMENTS});
        }
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }

     private async getPartnerProfile() {
        const partnerService = ObjectFactory.getPartnerService();
        const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
        if (response.success && response.data) {
            const partnerProfile = response.data;
            if (partnerProfile.transporterProfile) {
                for (const document of partnerProfile.transporterProfile.documents) {
                    if (document.rejected) {
                        this.isRejected = true;
                        break;
                    }
                }
            }
        }
    }
}
